import { formatDate } from '@angular/common';
import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_77 implements Validator {

	public static id = 'CTRL_77';
	private message = 'error.ctr_77';


	public LOG: LogService = new LogService(CTRL_77);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_77.id + '_');	  


		if (rgs.length > 0) {
		  for (const rg of rgs) {
			const ctrl = form.controls[rg];
			const dateWithStepId = map.get(ctrl.value.rgCtrls.date);
			const dateCtrl = form.controls[dateWithStepId];
	  
			const minDate = new Date();
			minDate.setDate(minDate.getDate() + 10);
			minDate.setHours(0, 0, 0, 0); 
	  		const receptionDate = new Date(dateCtrl.value);
			receptionDate.setHours(0, 0, 0, 0); 
	  
	  
			if (dateCtrl.value !== 'yyyy-MM-dd' && dateCtrl.value !== "") {
			  if (receptionDate <= minDate) {
				// placer le message d'erreur
				form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
			  } else {
				form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };

			  }
			}
		  }
		}
	  }
}
